import { Alert } from 'antd';
import { Link } from 'react-router-dom';
import { ROUTES } from '@/app/router/routes';

export function ClassificationWorkflowRequiredAlert({ yearLabel }: { yearLabel: string }) {
  return (
    <Alert
      type="warning"
      showIcon
      className="mb-4"
      message="Classification workflow required"
      description={
        <span>
          No classification workflow is configured for <strong>{yearLabel}</strong>. Configure a workflow for this
          year in{' '}
          <Link to={ROUTES.reportsManageClassification} className="font-semibold text-amber-950 underline">
            Manage Classification
          </Link>{' '}
          before you can view or manage this report.
        </span>
      }
    />
  );
}
